import { DatePicker } from "antd";
import dayjs from "dayjs";
import { useEffect, useRef, useState } from "react";
import 'react-accessible-accordion/dist/fancy-example.css';
import { Modal } from "react-bootstrap";
import ReactPaginate from "react-paginate";
import { connect, useDispatch } from "react-redux";
import Select from "react-select";
import { Col, Input, Row, Table } from "reactstrap";
import swal from "sweetalert";
import Swal from "sweetalert2";
import "../../../css/settings.scss";
import { logout } from "../../../store/actions/AuthActions";
import { api } from "../../../utils/api";
import { shownItem } from "../../../utils/config";
import { translate } from "../../../utils/translate";
import LoadingV3 from "../../components/Loading/LoadingV3";
import NotFound from "../Common/NotFound";
import customSelectStyles from '../SelectStyle';
const { RangePicker } = DatePicker;

const statusList = [
    { label: "Pending", value: "Pending" },
    { label: "Approved", value: "Approved" },
    { label: "Rejected", value: "Rejected" },
]

const MemberKyc = (props) => {
    const dispatch = useDispatch();

    const [productPerpage, setProductPerpage] = useState(10);
    const [pageCount, setPageCount] = useState(0);
    const [loading, setLoading] = useState(false);
    const [pageNumber, setPageNumber] = useState(1);
    const [result, setResult] = useState([]);
    const [email, setEmail] = useState('');
    const [status, setStatus] = useState('Pending');
    const [from, setFrom] = useState("");
    const [to, setTo] = useState("");
    const [modal, setModal] = useState(false);
    const [firstLoad, setFirstLoad] = useState(true);
    const timerRef = useRef(null);
    const [rejectID, setRejectID] = useState('');
    const [formData, setFormData] = useState({
        nickName: '',
        trxPassword: '',
        confirmTrxPassword: '',
        email: '',
        role: '',
        id: '',
        referralCode: '',
        sponsorName: '',
        phoneNo: '',
        dob: '',
        ranking: '',
        remark: '',
        status: '',
        countryCode: '',
        remark: "",
        productPerpage: "10"
    });
    let errorsObj = { remark: "" };
    const [errors, setErrors] = useState(errorsObj);

    const changePage = (event) => {
        setPageNumber(event.selected + 1);
        getMemberDetails(event.selected + 1)
    }

    useEffect(() => {
        if (firstLoad) {
            getMemberDetails();
            setFirstLoad(false);
        }
    }, []);

    useEffect(() => {
        if (!firstLoad) {
            setPageNumber(1);
            getMemberDetails(1);
        }
    }, [email, productPerpage, from, to, status, props.lang]);

    const handleTimeChange = (e) => {
        if (e) {
            const formattedFromDate = dayjs(e[0]).format("YYYY-MM-DD");
            const formattedToDate = dayjs(e[1]).format("YYYY-MM-DD");
            setFrom(formattedFromDate);
            setTo(formattedToDate);
        } else {
            setFrom("");
            setTo("");
        }
    }

    const getMemberDetails = (page = pageNumber) => {
        setLoading(true);
        clearTimeout(timerRef.current);
        timerRef.current = setTimeout(() => {
            let url = api.get_customer_approvals + `?page=${page}`;
            if (email) {
                url += `&email=${email}`;
            }
            if (from && to) {
                url += `&date_start=${from}&date_end=${to}`
            }
            if (status) {
                url += `&status=${status}`

            }
            if (productPerpage) {
                url += `&limit=${productPerpage}`

            }
            fetch(url, {
                method: "GET",
                headers: new Headers({
                    "Content-Type": "application/json",
                    "Accept-Language": props.lang.toLowerCase(),
                    "Authorization": "Bearer " + props.auth.auth.access_token
                }),
            })
                .then(response => response.json())
                .then(responseJson => {
                    setTimeout(() => {
                        setLoading(false);
                    }, 1000);
                    if (responseJson.status === "success") {
                        setResult(responseJson.data.results);
                        var pageCount = Math.ceil(responseJson.data.total_results / productPerpage)
                        setPageCount(pageCount);
                    } else {
                        if (responseJson.status === 'error' && responseJson.message.toLowerCase() === 'token expired') {
                            dispatch(logout(props.history, 'login'));
                        }
                    }
                }).catch(error => {
                    console.error("error", error);
                });
        }, 1000);
    }

    const handleAddFormChange = (event) => {
        event.preventDefault();
        const fieldName = event.target.getAttribute('name');
        let fieldValue = event.target.value;
        const newFormData = { ...formData };
        newFormData[fieldName] = fieldValue;
        setFormData(newFormData);
    }

    const action = (id, action) => {
        Swal.fire({
            title: translate(props.lang, `Attention`),
            text: translate(props.lang, `Do you want to ${action} this member?`),
            icon: "warning",
            showCancelButton: true,
            cancelButtonColor: "#A4B6E1",
            confirmButtonText: translate(props.lang, 'Ok'), // Add the translation for 'OK' here
            cancelButtonText: translate(props.lang, 'Cancel'), // Add the translation for 'Cancel' here
            customClass: {
                // Add the custom CSS class to the Swal dialog
                popup: 'swal2-popup',
                actions: 'swal2-actions'
            }

        }).then(function (result) {
            if (result.isConfirmed) {
                actionKyc(id, action)
            }
        });
    }

    const actionKyc = (id, action) => {
        let url
        if (action === "approve") {
            url = "/approve_customer_approval"
        }
        else {
            setModal(true);
            setRejectID(id);
            return;
        }
        fetch(api.admin + `${url}/${id}`, {
            method: "PUT",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept-Language": props.lang,
                "Authorization": "Bearer " + props.auth.auth.access_token
            }),
        })
            .then(response => response.json())
            .then(responseJson => {
                if (responseJson.status === "success") {
                    getMemberDetails();
                    setModal(false);
                    swal(translate(props.lang, "Success"), responseJson.message, "success");
                } else {
                    if (responseJson.status === 'error' && responseJson.message.toLowerCase() === 'token expired') {
                        dispatch(logout(props.history, 'login'));
                    }
                    swal(translate(props.lang, "Error"), responseJson.message, "error");
                }

            }).catch(error => {
                console.error("error", error);
            });
    }

    const submitRemark = () => {
        let check = true;
        const errorMsg = { ...errorsObj };
        if (!formData.remark) {
            errorMsg.remark = 'This field is required.';
            check = false;
        }
        setErrors(errorMsg);
        if (check) {
            let data = {
                "remark": formData.remark
            }
            fetch(api.admin + `/reject_customer_approval/${rejectID}`, {
                method: "PUT",
                headers: new Headers({
                    "Content-Type": "application/json",
                    "Accept-Language": props.lang,
                    "Authorization": "Bearer " + props.auth.auth.access_token
                }),
                body: JSON.stringify(data)
            })

                .then(response => response.json())
                .then(responseJson => {
                    if (responseJson.status === "success") {
                        getMemberDetails();
                        setModal(false);
                        swal(translate(props.lang, "Success"), responseJson.message, "success");
                    } else {
                        if (responseJson.status === 'error' && responseJson.message.toLowerCase() === 'token expired') {
                            dispatch(logout(props.history, 'login'));
                        }
                        swal(translate(props.lang, "Error"), responseJson.message, "error");
                    }

                }).catch(error => {
                    console.error("error", error);
                });
        }
    }

    return (
        <>
            <div className='pb-5 wallet'>
                <Row className="mx-0 px-0 mt-3 mt-md-0">
                    <Col lg={12} md={12} sm={12} xs={12} className="px-0">
                        <div className="whiteContainer px-md-4 py-md-4 p-2">
                            <div className="tableContainer">
                                <Row className="align-items-center">
                                    <Col lg={4} md={4} sm={12} xs={12} className="mt-3">
                                        <div className="groupLabel-input">
                                            <div className="input-group">
                                                <Input
                                                    type="text"
                                                    placeholder={translate(props.lang, "Enter Member Email")}
                                                    className="form-control input-transparent py-1 px-3"
                                                    onChange={e => setEmail(e.target.value)}
                                                    value={email}
                                                />
                                            </div>
                                        </div>
                                    </Col>
                                    <Col lg={4} md={4} sm={12} xs={12} className="mt-3">
                                        <RangePicker
                                            className="w-100 input-transparent"
                                            placeholder={[
                                                translate(props.lang, "From"),
                                                translate(props.lang, "To"),
                                            ]}
                                            onChange={(e) => handleTimeChange(e)}
                                        />
                                    </Col>
                                    <Col lg={4} md={4} sm={12} xs={12} className="mt-3">
                                        <div className="input-group-select select-placeholder-center">
                                            <Select
                                                options={
                                                    statusList.length > 0 ? statusList.map((item, i) => ({ key: i, value: item.value, label: translate(props.lang, item.label) })) : [{ value: '', label: translate(props.lang, "No options available") }]
                                                }
                                                placeholder={translate(props.lang, "Status")}
                                                className="input-transparent w-100 text-capitalize"
                                                styles={customSelectStyles}
                                                isSearchable={false}
                                                value={statusList.filter(item => item.value === status).map((item, i) => ({ key: i, value: item.value, label: translate(props.lang, item.label) }))}
                                                name="status"
                                                isClearable
                                                onChange={(e) => setStatus(e ? e.value : '')}
                                            />
                                        </div>
                                    </Col>
                                    <Col lg={4} md={4} sm={12} xs={12} className="mt-3">
                                        <div className="input-group-select select-placeholder-center">
                                            <Select
                                                options={
                                                    shownItem.length > 0 ? shownItem.map((item, i) => ({ key: i, value: item.value, label: item.label })) : [{ value: '', label: translate(props.lang, "No options available") }]
                                                }
                                                placeholder={translate(props.lang, "")}
                                                className="input-transparent w-100 text-capitalize"
                                                styles={customSelectStyles}
                                                value={shownItem && shownItem.find(option => option.value === productPerpage)}
                                                name="productPerpage"
                                                onChange={(e) => setProductPerpage(e.value)}
                                            />
                                        </div>
                                    </Col>
                                </Row>
                                <Table responsive className="w-100 table-list mt-3 text-center position-relative">
                                    <thead>
                                        <tr>
                                            <th className={`font-weight-600 font-16 text-black text-center`}>{translate(props.lang, "Submit Date")}</th>
                                            <th className={`font-weight-600 font-16 text-black text-center`}>{translate(props.lang, "Member Email")}</th>
                                            <th className={`font-weight-600 font-16 text-black text-center`}>{translate(props.lang, "Name")}</th>
                                            <th className={`font-weight-600 font-16 text-black text-center`}>{translate(props.lang, "Phone No")}</th>
                                            <th className={`font-weight-600 font-16 text-black text-center`}>{translate(props.lang, "Id No")}</th>
                                            <th className={`font-weight-600 font-16 text-black text-center`}>{translate(props.lang, "Front Image")}</th>
                                            <th className={`font-weight-600 font-16 text-black text-center`}>{translate(props.lang, "Back Image")}</th>
                                            <th className={`font-weight-600 font-16 text-black text-center`}>{translate(props.lang, "Hold Image")}</th>
                                            <th className={`font-weight-600 font-16 text-black text-center`}>{translate(props.lang, "Status")}</th>
                                            <th className={`font-weight-600 font-16 text-black text-center`}>{translate(props.lang, "Verify Date")}</th>
                                            <th className={`font-weight-600 font-16 text-black text-center`}>{translate(props.lang, "Remark")}</th>
                                            <th className={`font-weight-600 font-16 text-black text-center`}></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {loading ? (
                                            <tr>
                                                <td colSpan={12}>
                                                    <LoadingV3 theme='light' />
                                                </td>
                                            </tr>
                                        ) : (
                                            result.length > 0 ? (
                                                result.map((item, i) => (
                                                    <tr role="row" className={`${i % 2 === 0 ? 'even' : 'odd'}`} key={i}>
                                                        <td className={`font-weight-500 font-16 text-center`}>{item.date_added}</td>
                                                        <td className={`font-weight-500 font-16 text-center`}>{item.email}</td>
                                                        <td className={`font-weight-500 font-16 text-center`}>{item.full_name}</td>
                                                        <td className={`font-weight-500 font-16 text-center`}>{item.telephone}</td>
                                                        <td className={`font-weight-500 font-16 text-center`}>{item.id_number}</td>
                                                        <td>
                                                            {item.front_ic ? (
                                                                <a href={item.front_ic} target="_blank">
                                                                    <img src={item.front_ic} alt="front_ic" width="150" height="100" />
                                                                </a>
                                                            ) : '-'}
                                                        </td>
                                                        <td>
                                                            {item.back_ic ? (
                                                                <a href={item.back_ic} target="_blank">
                                                                    <img src={item.back_ic} alt="back_ic" width="150" height="100" />
                                                                </a>
                                                            ) : "-"}

                                                        </td>
                                                        <td>
                                                            {item.holding_attachment ? (
                                                                <a href={item.holding_attachment} target="_blank">
                                                                    <img src={item.holding_attachment} alt="holding_ic" width="150" height="100" />
                                                                </a>
                                                            ) : "-"}
                                                        </td>
                                                        <td className={`font-weight-500 font-16 text-center status ${item.status.toLowerCase()}`}>{translate(props.lang, item.status)}</td>
                                                        <td className={`font-weight-500 font-16 text-center`}>{item.date_modified ? item.date_modified : "-"}</td>
                                                        <td className={`font-weight-500 font-16 text-center`}>{item.remark ? item.remark : "-"}</td>
                                                        <td className={`font-weight-500 font-16 text-center`}>
                                                            {item.status !== "Rejected" && item.status !== "Approved" && (
                                                                <>
                                                                    <button className="primary-btn py-1 text-center mx-auto px-4" onClick={() => { action(item.customer_approval_id, "approve") }}>
                                                                        <span className={`btnText`}>{translate(props.lang, "Approve")}</span>
                                                                    </button>
                                                                    <button className="deleteBtn py-1 text-center mx-auto px-4 ms-2" onClick={() => { action(item.customer_approval_id, "reject") }}>
                                                                        <span className={`btnText`}>{translate(props.lang, "Reject")}</span>
                                                                    </button>
                                                                </>
                                                            )}
                                                        </td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr role="row" className={`even`}>
                                                    <td colSpan={12}>
                                                        <NotFound />
                                                    </td>
                                                </tr>
                                            )
                                        )}
                                    </tbody>
                                </Table>
                            </div>
                            <div className="pt-4">
                                {!loading && result.length > 0 ? (
                                    <div className="my-3">
                                        <ReactPaginate
                                            previousLabel={"<"}
                                            nextLabel={">"}
                                            pageCount={pageCount}
                                            forcePage={pageNumber - 1}
                                            onPageChange={changePage}
                                            containerClassName={"pagination font-weight-500 font-16 text-uppercase text-grey-2"}
                                            previousLinkClassName={"pagination__previouslink pagination-arrow"}
                                            nextLinkClassName={"pagination__nextlink pagination-arrow"}
                                            disabledClassName={"pagination__link--disabled text-muted"}
                                            activeClassName={"pagination__link--active text-black"}
                                            marginPagesDisplayed={window.innerWidth > 667 ? 3 : 1}
                                        />
                                    </div>
                                ) : null}
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>
            <Modal className="fade bgImgModal" show={modal} centered>
                <Modal.Header className="border-0 pt-4 pb-2">
                    <div className="d-flex w-100 align-items-center">
                        <div className="w-75"></div>
                        <div className="w-25 text-end cursor-pointer" onClick={() => { setModal(false) }} >
                            <svg width="20" height="20" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M26 3L3 26" stroke="#777777" strokeWidth="5" strokeLinecap="round" />
                                <path d="M3.00928 3L26.0093 26" stroke="#777777" strokeWidth="5" strokeLinecap="round" />
                            </svg>
                        </div>
                    </div>
                </Modal.Header>
                <Modal.Body className="border-0 px-3">
                    <div className='modalBody'>
                        <div className="px-0 px-md-4">
                            <Row className="justify-content-start px-0 mx-0">
                                <Col lg={12} md={12} sm={12} xs={12} className="my-3">
                                    <div className="text-center mb-3">
                                        <span className="font-weight-600 font-30 text-black">{translate(props.lang, "Reject Reason")}</span>
                                    </div>
                                </Col>
                                <Col lg={12} md={12} sm={12} xs={12} className="mt-3">
                                    <span className="font-16 font-weight-600 text-grey-2">{translate(props.lang, "Remark")}</span>
                                    <div className={`groupLabel-input mt-2 mb-1  ${errors.remark ? 'errorBorder' : ''}`}>
                                        <div className={`input-group`}>
                                            <Input
                                                type="text"
                                                placeholder={translate(props.lang, "Enter Remark")}
                                                className="form-control input-transparent py-1 px-3"
                                                name="remark"
                                                value={formData.remark}
                                                onChange={e => handleAddFormChange(e)}
                                            />
                                        </div>
                                    </div>
                                    <span className="font-weight-400 font-14 errorTextRed ms-0">{translate(props.lang, errors.remark)}</span>
                                </Col>
                                <Col lg={12} md={12} sm={12} xs={12} className="mt-4">
                                    <button className="primary-btn px-4 py-1 text-center mx-auto w-100" onClick={() => submitRemark()}>
                                        <span className={`font-weight-600 font-20 line-height-30 text-white`}>{translate(props.lang, "Submit")}</span>
                                    </button>
                                </Col>
                            </Row>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}

const mapStateToProps = state => {
    const { auth, i18n } = state;
    return {
        lang: i18n.lang,
        auth: auth,
    }
}

export default connect(mapStateToProps)(MemberKyc);